import Grid from '@mui/material/Grid';

import FtpAccess from '../../../components/FtpAccess';
import IPAddress from '../../../components/IPAddress';
import NameServers from '../../../components/NameServers';
import SSHAccess from '../../../components/SSHAccess';
import { PackageDetailsInfo } from '../../../utils/types';

interface SharedInfoProps {
  details: PackageDetailsInfo;
  hostingPlanId: string;
  backReference: string;
}

const SharedInfo = ({
  details,
  hostingPlanId,
  backReference,
}: SharedInfoProps) => {
  const { nameServers, sshKey, ipAddress } = details || {};

  return (
    <Grid container spacing={2}>
      <Grid item xs={12} md={3}>
        <NameServers servers={nameServers ?? []} />
      </Grid>
      <Grid item xs={12} md={3}>
        <SSHAccess
          sshKey={sshKey ?? ''}
          hostingPlanId={hostingPlanId}
          backReference={backReference}
        />
      </Grid>
      <Grid item xs={12} md={3}>
        <FtpAccess
          hostingPlanId={hostingPlanId}
          backReference={backReference}
        />
      </Grid>
      <Grid item xs={12} md={3}>
        <IPAddress ip={ipAddress ?? ''} />
      </Grid>
    </Grid>
  );
};

export default SharedInfo;
